/*@ngInject*/
const RuleActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadRuleAction = function (uri) {
        var url = '/rest/Actions',
            config = {
                params: {
                    uri: uri
                }
            };
        return this.get(url, config);
    };

};

angular.module('ums.configuration')
    .service('ruleActionRepository', RuleActionRepository);
